import { DEFAULT_TABLE_SIZE, TABLE_SIZE_THEMES } from '../consts';
export default (function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TABLE_SIZE;
  return TABLE_SIZE_THEMES[size];
});
//# sourceMappingURL=getTableTheme.js.map